import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Layout, Menu, Avatar, Drawer, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getUser, userSelector } from '../../store/session'
import { AUTH_TOKEN_KEY } from '../../app/contants'
import { withRoleAccess } from '../../app/hooks/withRoleAccess'
import useAuth from '../../app/hooks/useAuth'

const { Header } = Layout

const HeaderNavigation = ({ activeKey }) => {
  const dispatch = useDispatch()
  const { setAuthToken } = useAuth()
  let navigate = useNavigate()
  const { user } = useSelector(userSelector)
  const [showDrawer, setShowDrawer] = useState(false)
  const avatarName = useMemo(() => {
    if (user?.first_name && user?.second_name) {
      return `${user.first_name.charAt(0)}${user.second_name.charAt(0)}`.toUpperCase()
    }
  }, [user])

  useEffect(() => {
    dispatch(getUser())
  }, [dispatch])

  const onMenuClick = useCallback(
    (route) => () => {
      navigate(`/${route}`)
    },
    [navigate]
  )

  const logoutHandler = () => {
    localStorage.removeItem(AUTH_TOKEN_KEY)
    setAuthToken(null)
  }

  const RoleAccessMenuItem = withRoleAccess(Menu.Item)

  return (
    <>
      <Header style={{ position: 'fixed', zIndex: 3, width: '100%' }}>
        <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']} selectedKeys={[activeKey]}>
          <Menu.Item key="1" onClick={onMenuClick('applications')}>
            Заявки
          </Menu.Item>
          <RoleAccessMenuItem
            key="2"
            allowedRoles={['project_manager', 'estimator', 'accountant']}
            onClick={onMenuClick('projects')}
          >
            Проекты
          </RoleAccessMenuItem>
          <RoleAccessMenuItem key="3" allowedRoles={['project_manager']} onClick={onMenuClick('analytics')}>
            Отчеты
          </RoleAccessMenuItem>
          <RoleAccessMenuItem
            key="4"
            allowedRoles={['project_manager', 'foreman', 'supplier']}
            onClick={onMenuClick('stockroom')}
          >
            Склад
          </RoleAccessMenuItem>
          <RoleAccessMenuItem key="5" allowedRoles={['project_manager', 'estimator']} onClick={onMenuClick('acts')}>
            Акты
          </RoleAccessMenuItem>
          <RoleAccessMenuItem key="6" allowedRoles={['project_manager']} onClick={onMenuClick('employees')}>
            Пользователи
          </RoleAccessMenuItem>
        </Menu>
        <div style={{ top: 0, right: 50, position: 'absolute', cursor: 'pointer' }}>
          <Avatar onClick={() => setShowDrawer(true)} size={40}>
            {avatarName}
          </Avatar>
        </div>
      </Header>
      <Drawer
        title="Пользователь"
        visible={showDrawer}
        placement="right"
        onClose={() => setShowDrawer(false)}
        extra={<Button onClick={logoutHandler}>Выйти</Button>}
      >
        <div>
          <span style={{ fontWeight: 'bold' }}>Имя: </span>
          <span>{`${user.first_name} ${user.second_name}`}</span>
        </div>
        <div>
          <span style={{ fontWeight: 'bold' }}>Почта: </span>
          <span>{user.email}</span>
        </div>
        <div>
          <span style={{ fontWeight: 'bold' }}>Роль: </span>
          <span>{user?.role?.name}</span>
        </div>
      </Drawer>
    </>
  )
}

export default HeaderNavigation
